export enum ACTION_TEXT {
  INVITE_TO_APPLY = 'Invite to apply',
  RESEND_APPLICATION = 'Resend application',
  VIEW_APPLICATION = 'View application',
}

export type GetApplicationActionTextArgs = {
  isApplicationCompleted: boolean;
  hasSentApplication: boolean;
};

/**
 * Returns the application action label based on application state
 * (e.g. "View application", "Resend application", "Invite to apply").
 * Shared by the contacts page and inbox page.
 */
export default function getApplicationActionText({
  isApplicationCompleted,
  hasSentApplication,
}: GetApplicationActionTextArgs): ACTION_TEXT {
  if (isApplicationCompleted) {
    return ACTION_TEXT.VIEW_APPLICATION;
  } else if (hasSentApplication) {
    return ACTION_TEXT.RESEND_APPLICATION;
  } else {
    return ACTION_TEXT.INVITE_TO_APPLY;
  }
}
